import React from 'react';
import {IndividualsFormTemplate} from "./IndividualsFormTemplate";

export function IndividualsFormCreate () {

    return (
        <IndividualsFormTemplate/>
    )
}